import { clsx } from 'clsx';
import { Link } from 'react-router';

import { AllNumbers } from '@/components/AllNumbers/AllNumbers.tsx';
import { Filters } from '@/components/PrettyNumbers/Filters/Filters.tsx';
import { useFilterStore } from '@/store';

import cn from './styles.module.sass';

export const PrettyNumbers = () => {
    const { isFiltersOpen } = useFilterStore();
    return (
        <div className={cn.container}>
            <div className={clsx(cn.prettyNumsTitle, isFiltersOpen && cn.hide)}>
                <Link to=".." className={cn.backBtn}>
                    <img src="/images/main/arrow_dark.svg" alt="" />
                </Link>
                <h2>Красивые номера</h2>
            </div>
            <main className={cn.prettyNums}>
                <Filters />
                <AllNumbers hasTitle={false} />
            </main>
        </div>
    );
};
